import Vue from 'vue'
import Router from 'vue-router'
import Schritt1 from './views/Schritt1.vue'
import Schritt2 from './views/Schritt2.vue'
import Schritt3 from "./views/Schritt3";
// import MobileAppCostCalc from "./components/MobileAppCostCalc";
import Switch from "./views/Switch";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        // {
        //     path: '/',
        //     name: 'AppCostCalc',
        //     component: () => import('./components/AppCostCalc.vue')
        // },
        {
            path: '/',
            component: Switch,
            children: [
                {
                    path: '/',
                    name: 'Schritt1',
                    component: Schritt1
                },
                {
                    path: '/schritt2',
                    name: 'Schritt2',
                    component: Schritt2
                },
                {
                    path: '/schritt3',
                    name: 'Schritt3',
                    component: Schritt3
                },
            ]
        },
        {
            path: '/subscribed=:message',
            component: Switch,
            children: [
                {
                    path: '/',
                    name: 'subshritt1',
                    component: Schritt1
                },
                {
                    path: '/schritt2',
                    name: 'subshritt2',
                    component: Schritt2
                },
                {
                    path: '/schritt3',
                    name: 'subshritt3',
                    component: Schritt3
                },
            ]
        },
        {
            path: '/Impressum',
            name: 'Impressum',
            component: () => import('./components/Impressum.vue')
        },
        {
            path: '/Datenschutz',
            name: 'Datenschutz',
            component: () => import('./components/Datenschutz.vue')
        },
        {
            path: '/mailchimp',
            name: 'mailchimp',
            component: () => import('./components/mailchimp.vue')
        }
    ],
    /* eslint-disable no-unused-vars */
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 500 }
    }
});


export default router;
